export default "__VITE_ASSET__BsdgphG1__"